<template>
    <div :class="['m-listingitem grid-item', resultItem.Featured ? 'featured' : '']">
        <div class="e-text">
            <p :class="['result-tag', resultItem.DocType.toLowerCase().trim()]">{{resultItem.DocumentTypeName.toUpperCase()}}</p>

            <h2><a :href="resultItem.Link.Url">{{resultItem.Heading}}</a></h2>

            <div class="buttons myhie">

                <p class="details" v-if="resultItem.DocType != 'event'">
                    <template v-if="resultItem.Date != null && resultItem.Subheading == ''">
                        <span>{{formatDate(resultItem.Date.DateTime)}}</span>
                    </template>
                    {{resultItem.Subheading}}

                    <template v-if="resultItem.Content.ArticleDetails != null && resultItem.Content.ArticleDetails.PodcastCount > 0">
                        <span class="read-time">{{resultItem.Content.ArticleDetails.PodcastCount}} <template v-if="resultItem.Content.ArticleDetails.PodcastCount == 1">episode</template><template v-if="resultItem.Content.ArticleDetails.PodcastCount > 1">episodes</template></span>
                    </template>
                </p>
                <ul class="details layout" v-if="resultItem.DocType == 'event'">
                    <li v-if="datesAreOnSameDay(resultItem.Content.EventStartDatetime, resultItem.Content.EventStartDatetime)">{{formatDate(resultItem.Content.EventStartDatetime, dateFormatUi())}}</li>
                    <li v-if="!datesAreOnSameDay(resultItem.Content.EventStartDatetime, resultItem.Content.EventStartDatetime)">{{formatDate(resultItem.Content.EventEndDatetime, dateFormatUi())}}</li>
                    <li>{{formatDate(resultItem.Content.EventStartDatetime, dateFormatTime())}} - {{formatDate(resultItem.Content.EventEndDatetime, dateFormatTime())}}</li>
                </ul>

                <profile-actions :page-id="resultItem.Id.toString()"></profile-actions>
            </div>

            <ul class="blog-tags layout" v-if="resultItem.Tagged != null">
                <template v-for="(tag, index) in resultItem.Tagged">
                    <li :key="tag">
                        <a v-bind:href="resultItem.TaggedFilterParamters[index]">{{tag}}</a>
                    </li>
                </template>
            </ul>
            <div class="taster">
                <p>{{resultItem.Summary}}</p>
            </div>

            <div class="buttons myhie">
                <a :href="resultItem.Link.Url" class="btn btn--inverse">Find out more</a>
            </div>
        </div>
    </div>
</template>

<script>
    import Globals from '@/globals.js'
    import ProfileActions from '@/components/Utils/profile-actions'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { format, toDate } from '@/utils/date.js'
    import { truncate } from '@/utils/strings.js'

    export default {
        components: {
            ProfileActions
        },

        methods: {
            
            dateFormatUi() {
                return Globals.dateFormatUi
            },

            dateFormatTime() {
                return Globals.dateFormatTime
            },

            datesAreOnSameDay(first, second) {
                var d1 = toDate(first)
                var d2 = toDate(second)

                return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
            },

            getDate(date) {
                return toDate(date)
            },

            formatDate(date, formatter) {
                return format(toDate(date), formatter || Globals.dateFormatMonthYear)
            },

            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        mixins: [globalMixin],

        props: {
            resultItem: {
                required: true,
                type: Object
            }
        }
    }
</script>
